import { render, staticRenderFns } from "./addSupplementaryInfo.vue?vue&type=template&id=83a8bf16&scoped=true&"
import script from "./addSupplementaryInfo.vue?vue&type=script&lang=js&"
export * from "./addSupplementaryInfo.vue?vue&type=script&lang=js&"
import style0 from "./addSupplementaryInfo.vue?vue&type=style&index=0&id=83a8bf16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a8bf16",
  null
  
)

export default component.exports